import Button from "@material-ui/core/Button";
import { withStyles, Theme } from "@material-ui/core";

const FancyButton = withStyles((theme: Theme) => ({
  root: {
    background: "linear-gradient(90deg, #F64F6E 0%, #FF8787 100%)",
    color: "white",
    boxShadow: "none",
  },
  disabled: {
    background: theme.palette.containerGrey,
    color: "white",
  },
}))(Button);

export default FancyButton;
